import type React from 'react'
import { useEffect } from 'react'
import styled from 'styled-components'

import Button from '@/components/Button'

interface Props {
  handleLogOut: Function
  loggedInAccount: any
  username?: string
}

const OnBoardingContainer = styled.div`
  iframe {
    border: none;
    width: 100%;
    height: 100vh;
  }
  h5 {
    font-size: 1.2rem;
  }

  #controls {
    margin: 0 10px;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 100;
  }
`

const Onboarding: React.FC<Props> = ({ handleLogOut, loggedInAccount, username }) => {
  function listenForMessages(event: any) {
    if (event.data === 'RELOAD_DASHBOARD') {
      window.location.reload()
    }
  }

  useEffect(() => {
    window.addEventListener('message', listenForMessages)

    return () => {
      window.removeEventListener('message', listenForMessages)
    }
  }, [])

  if (!loggedInAccount || !username) return <div>Loading...</div>
  return (
    <OnBoardingContainer>
      <div className="side-by-side-flex-end" id="controls">
        <h5>Not ready to onboard just yet?</h5>
        <Button $alternate onClick={() => handleLogOut()}>
          I'll do it later
        </Button>
      </div>
      <iframe
        title="Vouch Onboarding"
        src={`${import.meta.env.VITE_BOT_ONBOARD}?userId=${
          loggedInAccount.idTokenClaims.oid
        }&email=${username}`}
      ></iframe>
    </OnBoardingContainer>
  )
}

export default Onboarding
